import React from 'react';
import { useParams } from "react-router-dom";
import Leaderboard from "./Leaderboard";
import PageHeader from "../gamePlayComponents/PageHeader";
import Card from "@mui/material/Card";
import {courseFriendlyName} from "../courseContent/courseObjects";
import Typography from "@mui/material/Typography";

const LeaderboardContainer = () => {
  const { course } = useParams();
  const courseName = course || null;
  const friendlyCourseName = courseName && courseFriendlyName(courseName);
  return (
    <>
      <PageHeader title={`Leaderboard`} goBack/>
      <Typography variant={'subtitle2'} style={{textAlign: 'center', margin: '0 16px 8px'}} color={'primary'}>{`For the ${friendlyCourseName} course`}</Typography>
      <Card style={{padding: '16px'}}>
        <Leaderboard courseName={courseName} completeList />
      </Card>
      </>
  )
};

export default LeaderboardContainer;